import { formData, CheckDACH, setErrorReceived, ErrorMessage, generateData, responseData, CheckMessages, getErrorMessage } from '../../utils/data';
import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { permitRestrictions } from '../../utils/constants/constants';
import { Link, useNavigate } from 'react-router-dom';
import PrintPage from '../PrintPage';
import Loading from '../Loading';
import { useAuth } from '../../context/AuthContext';
import AddressTable from '../tables/addressTable';
import AliasTable from '../tables/aliasTable';
import EndorsementsTable from '../tables/endorsementsTable';
import MedicalCertTable from '../tables/medcertTable';
import RestrictionTable from '../tables/restrictionsTable';
import PermitTables from '../tables/permitTable';
import { createLog } from '../datawriter/createLog';
import "../print.css"

function InquiryResponse() {
    const [testData, setTestData] = useState({});
    const [loading, setLoading] = useState(true);
    const [requestID, setRequestID] = useState('')
    const [driverPhoto, setDriverPhoto] = useState('');
    const [show, setShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState([]);


    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const navigate = useNavigate();
    const { token, email, state, roles } = useAuth();
    console.log("Data form: ", formData);
    
    useEffect(() => {
        //createLog("", email);
        const fetchData = async () => {
          try {
            console.log("Fetching data from API...", formData);
            const country = formData.Body.DriverRequest.DriverLicense.LicenseCountry;
            const specialCountries = ['OTH', 'US-T'];
            const isSpecialCase = specialCountries.includes(country) || (country === 'CA' && roles.includes('searchCnFcwd'));
            const endpoint = isSpecialCase ? '/api/fcwd-only' : '/api/status';
            await responseData(endpoint, token)
            .then(function (response) {
                createLog(response, email)
                if(response?.Response?.DriverDetails?.PersonDetails !== undefined) {
                    if(formData.Body.DriverRequest.DriverLicense.LicenseCountry === 'MX'){
                        if(response.Response.DriverDetails.PersonDetails?.DriverPhoto){
                            const photo = atob(response.Response.DriverDetails.PersonDetails.DriverPhoto)
                            console.log("photo received", photo)
                            setDriverPhoto(photo)
                            
                        }
                    }
                    setErrorMessage(response.Messages);
                    setTestData(response);
                    console.log("Completed:",response);
                    setRequestID(response.TransactionGUID);
                    setLoading(false);
                } else {
                    setErrorReceived(CheckMessages(response.Messages));
                    if (response?.Response?.DriverDetails?.Confirmations !== undefined) {
                        const confirmations = response.Response.DriverDetails.Confirmations;

                        if (confirmations.DriverLicense?.LicenseNumber === "INVALID") {
                            navigate(-1);
                            return; // No need to check further
                        }
                        const kvPairs = generateData(confirmations);
                        let invalidMessage = "Unified Driver Search Processing Error";
                        console.log("Pairs are here:", kvPairs);
                        for (let index = 0; index < kvPairs.length; index++) {
                            const key = kvPairs[index];
                            if (key === 'DriverFirstName') {
                                invalidMessage += ": First Name Does Not Match Provincial Record";
                            } else if (key === 'DriverLastName') {
                                invalidMessage += ": Last Name Does Not Match Provincial Record";
                            } else if (key === 'LicenseState') {
                                invalidMessage += ": Jurisdiction Does Not Match Provincial Record";
                            } else if (key === 'DriverDOB') {
                                invalidMessage += ": Date of Birth Does Not Match Provincial Record";
                            }
                        }
                        setErrorReceived([invalidMessage + " - No Data found in FCWD;"]);
                    }
                    navigate(-1);
                }
            })
            .catch(  (error) => {
                console.error('Error logged here:', error);
                setErrorReceived([getErrorMessage(error, 'Unable to retrieve inquiry results. Please try again.')]);
                navigate(-1);
            })
            
          } catch (error) {
            console.error('caught error: ', error);
            setErrorReceived([getErrorMessage(error, 'Unable to retrieve inquiry results. Please try again.')]);
            navigate(-1);
          }
            
          
        };
    
        fetchData();
    }, []);
  
    if(loading){
        return(<>
            <Loading />
            </>)
    }
    
    const td = {
        "Response":{
            "DriverDetails":{
                "PersonDetails":{
                    "PersonName":{
                        "FirstName":"Roberto",
                        "MiddleName":"",
                        "SurName":"Gonzales",
                        "Suffix":"Sr"
                    },
                    "CRUP":"a",
                    "RFC":"b",
                    "DOB":"1953-04-26",
                    "PhysicalDetails":{
                        "Height":70,
                        "Weight":200,
                        "EyeColor":"Brn",
                        "Sex":"N"
                    },
                    "ResidenceAddress":{
                            
                    }
                },
                "DriverDetails":{
                    "Licence":{
                        "JurisdictionOfIssue":"MX",
                        "IssueDate":"2012-03-12",
                        "LicenseNumber":"TAMP106805",
                        "ExpirationDate":"2017-03-12",
                        "CommercialClassCode":"B",
                        "NonCommercialClassCode":"N/A",
                        "WithdrawalActionPending":"N/A",
                        "LicenseCountry":"MX",
                        "Endorsements":"NI - Non-excepted Interstate",
                        "MedicalCertificate":"",
                        "Restrictions":"None",
                        "Permits":"N/A",
                    },
                    "Convictions":[],
                    "Accidents":[],
                    "Withdrawls":[]
                }
            },
            "DACH_Status":""

        },
        "formData":{
            "Body":{
                "DriverRequest":{
                    "DriverLicense":{
                        "LicenceState":'MX'
                    }
                }
            }
        }
    };
   // const [testData, setTestData] = useState(td);

   //alert(JSON.stringify(errorMessage))
  
    return(
        <>
        <div id='print-area'>
             <CheckDACH dach={testData.Response.DACH_Status}/> 
            {errorMessage.map((message => (
                <ErrorMessage value={message} />
            )))}
            <div id='table'>
                    
            <div style={{ fontSize:'small', width: '-webkit-fill-available', background: 'white'}}>
                <div id="banner-results">
                
                <h4>History Search Results</h4>
                <h6 style={{ textAlign: '-webkit-right' }}>
                    <span style={{float: 'left' }}>/{formData.Body.DriverRequest.DriverLicense.LicenseState}/{formData.Body.DriverRequest.DriverLicense.LicenseNumber}</span>
                    <img className="print-only" id='mxPhoto' loading="eager" style={{width:'100px'}}/>
                    <br />
                    <span>{requestID}</span>
                    <br/>
                    
                </h6>
                </div>{driverPhoto !== '' &&
                        <bold><button class="btn btn-primary" onClick={handleShow} style={{float:'right', fontSize:'large'}}>
                        Driver Photo
                      </button>
                
                      <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" show={show} onHide={handleClose} centered>
                        <Modal.Header closeButton>
                          <Modal.Title>Driver Photo</Modal.Title>
                        </Modal.Header>
                        <Modal.Body><img loading="eager" id='mxPhoto' className="small" style={{width: '-webkit-fill-available'}} src={driverPhoto} /></Modal.Body>
                        <Modal.Footer>
                          <Button variant="secondary" onClick={handleClose}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal></bold>
                        }{testData.Response.DriverDetails.PersonDetails !== undefined &&
                <><th>Driver General Information</th>
            <table className="table table-striped table-bordered">

                            <thead style={{ width: '100%' }}>
                                <tr>
                                    <th scope="col">First Name</th>
                                    <th scope="col">Middle Name</th>
                                    <th scope="col">Last Name</th>
                                    <th scope="col">Suffix</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(testData.Response.DriverDetails.PersonDetails && testData.Response.DriverDetails.PersonDetails.PersonName) &&
                                    <tr>
                                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.FirstName}</td>
                                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.MiddleName}</td>
                                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.SurName}</td>
                                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.Suffix}</td>
                                    </tr>}
                            </tbody>
                        </table><table className="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        {formData.Body.DriverRequest.DriverLicense.LicenseState === 'MX' &&

                                        <><th scope="col">CURP</th>
                                        <th scope="col">RFC</th></>}
                                        <th scope="col">Date of Birth</th>
                                        <th scope="col">Height</th>
                                        <th scope="col">Weight</th>
                                        <th scope="col">Eye Color</th>
                                        <th scope="col">Sex</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        {testData.Response.DriverDetails.PersonDetails &&
                                            <>
                                                {formData.Body.DriverRequest.DriverLicense.LicenseState === 'MX' &&
                                                    <><td>{testData.Response.DriverDetails.PersonDetails.CURP}</td>
                                                        <td>{testData.Response.DriverDetails.PersonDetails.RFC}</td></>}
                                                <td>{testData.Response.DriverDetails.PersonDetails.DOB}</td>
                                                {testData.Response.DriverDetails.PersonDetails.PhysicalDetails &&
                                                    <><td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.Height}</td>
                                                        <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.Weight}</td>
                                                        {testData?.Response?.DriverDetails?.PersonDetails?.PhysicalDetails?.EyeColor?.split('-')[1] ? <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.EyeColor.split('-')[1]}</td>: <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.EyeColor}</td>}
                                                        <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.Sex}</td></>}</>}
                                    </tr>
                                </tbody>
                            </table><div>
                                <AddressTable label="Residence Address" address={testData.Response.DriverDetails?.ResidenceAddress || testData.Response.DriverDetails} />
                                <AddressTable label="Mailing Address" address={testData.Response.DriverDetails.PersonDetails?.MailingAddress || testData.Response.DriverDetails.MailingAddress} />

                                <AliasTable alias={testData.Response.DriverDetails.Alias} />
                            </div><th>Driver License Details</th><table className="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">Jurisdiction</th>
                                        <th scope="col">Driver License</th>
                                        <th scope="col">Issue Date</th>
                                        <th scope="col">Expiration Date</th>
                                        <th scope="col">Commercial Class</th>
                                        <th scope="col">Commercial Status</th>
                                        <th scope="col">Non Commercial Class</th>
                                        <th scope="col">Non Commercial Status</th>
                                        <th scope="col">Withdrawal Action Pending</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        {testData.Response.DriverDetails.License &&
                                            <><td>{testData.Response.DriverDetails.License.JurisdictionOfIssue}</td>
                                                <td>{testData.Response.DriverDetails.License.LicenseNumber}</td>
                                                <td>{testData.Response.DriverDetails.License.IssueDate}</td>
                                                <td>{testData.Response.DriverDetails.License.ExpirationDate ?? testData.Response.DriverDetails.License.ExpiryDate}</td>
                                                <td>{testData.Response.DriverDetails.License.CommercialClassCode}</td>
                                                {testData.Response.DriverDetails.License.CommercialStatus.split('-')[1] ? <td>{testData.Response.DriverDetails.License.CommercialStatus.split('-')[1]}</td> : <td>{testData.Response.DriverDetails.License.CommercialStatus}</td>}
                                                <td>{testData.Response.DriverDetails.License.NonCommercialClassCode}</td>
                                                {testData.Response.DriverDetails.License.NonCommercialStatus.split('-')[1] ? <td>{testData.Response.DriverDetails.License.NonCommercialStatus.split('-')[1]}</td> : <td>{testData.Response.DriverDetails.License.NonCommercialStatus}</td>}
                                                <td>{testData?.Response?.DriverDetails?.License?.WithdrawalActionPending?.split('-')[1]}</td></>}
                                    </tr>
                                </tbody>
                            </table><div>
                                    <><EndorsementsTable endorsements={testData.Response.DriverDetails.Endorsements} />
                                        <MedicalCertTable medCert={testData.Response.DriverDetails.MedicalCertificate} 
                                        medName={testData.Response.DriverDetails.MedicalExaminerName}
                                        med={testData.Response.DriverDetails.MedicalExaminer}
                                        medRest={testData.Response.DriverDetails.MedicalCertificateRestrictionCode}/>
                                        <RestrictionTable restrictions={testData.Response.DriverDetails.Restrictions} />
                                        <PermitTables permits={testData.Response.DriverDetails.Permits} /></>

                            </div><table className="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">Convictions</th>
                                        <th scope="col">Accidents</th>
                                        <th scope="col">Withdrawals</th>
                                        <th scope="col">Permits</th>
                                        <th scope="col">License Restrictions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <>
                                        {testData.Response.DriverDetails.License.Total_ACD_ConvictionsOnRecord ? <td>{testData.Response.DriverDetails.License.Total_ACD_ConvictionsOnRecord}</td> : <td>{testData?.Response?.DriverDetails?.Convictions?.length ?? 0}</td> }
                                        {testData.Response.DriverDetails.License.TotalAccidentsOnRecord ? <td>{testData.Response.DriverDetails.License.TotalAccidentsOnRecord}</td> : <td>{testData?.Response?.DriverDetails?.Accidents?.length ?? 0}</td> }
                                        {testData.Response.DriverDetails.License.TotalWithdrawalsOnRecord ? <td>{testData.Response.DriverDetails.License.TotalWithdrawalsOnRecord}</td> : <td>{testData?.Response?.DriverDetails?.Withdrawals?.length ?? 0}</td> }
                                        {testData.Response.DriverDetails.License.NumberOfPermits ? <td>{testData.Response.DriverDetails.License.NumberOfPermits}</td> : <td>{testData?.Response?.DriverDetails?.Permits?.length ?? 0}</td> }
                                        {testData.Response.DriverDetails.License.NumberOfRestrictions ? <td>{testData.Response.DriverDetails.License.NumberOfRestrictions}</td> : <td>{testData?.Response?.DriverDetails?.Restrictions?.length ?? 0}</td> }
                                        </>
                                    </tr>
                                </tbody>
                            </table><div>
                                {(formData.Body.DriverRequest.DriverLicense.LicenseCountry === 'CA' && testData.Response.DriverDetails.License) &&
                                    <><CheckCanadianSuspension suspension={testData.Response.DriverDetails.License.Suspension} /></>}
                                    <><CheckConvictions convictions={testData.Response.DriverDetails.Convictions} />
                                        <CheckAccidents accidents={testData.Response.DriverDetails.Accidents} />
                                        <CheckWithdrawals withdrawals={testData.Response.DriverDetails.Withdrawals} /></>
                            </div></>
                        }
                </div>
            </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
            <a href='/'><button type="button" class="btn btn-primary" id="button">Done</button></a>
            <PrintPage
            type="inquiry"
            response={testData.Response}
            queryLine={`/${formData.Body.DriverRequest.DriverLicense.LicenseState}/${formData.Body.DriverRequest.DriverLicense.LicenseNumber}`}
            transactionID={requestID}
            driverPhotoBase64={driverPhoto || ''}
            messages={errorMessage}
            />

         </div>
         </div></>
    );
}
function CheckPermits({permits}) {
    if (permits !== undefined && permits.length > 0) {
    return (<div>
        {permits.map((permit => (
        <><th>Permit Class {permit.CommercialClassCode}</th>
        <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th scope="col">Issue Date</th>
                        <th scope="col">Expiration Date</th>
                        <th scope="col">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{permit.IssueDate}</td>
                        <td>{permit.ExpirationDate}</td>
                        {permit.Status.split('-')[1] ? <td>{permit.Status.split('-')[1] }</td> : <td>{permit.Status}</td>}
                    </tr>
                    
                </tbody>
        </table>
        <th>Permit Class {permit.CommercialClassCode} Restrictions</th>
        <table className="table table-striped table-bordered">
            <thead>
                <tr>
                    <th scope="col">Value</th>
                </tr>
            </thead>
            <tbody>
                {permit.Restrictions.map((details => (
                    <tr>
                        {details.RestrictionText === "" ? <td>{permitRestrictions[details.Code]}</td> : <td>{details.RestrictionText}</td>}
                    </tr>
                )))}
            </tbody>
        </table></>
        )))}
    </div>)
    }
    return
}
function CheckCanadianSuspension({suspension}) {
    if(suspension !== undefined && suspension !== null && suspension.SuspensionTypes.length > 0){
        return (
            <><th>Canadian Suspensions</th><table className="table table-striped table-bordered" >
                <thead>
                    <tr>
                        <th scope="col">Suspension Start Date</th>
                        <th scope="col">Suspension End Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{suspension.StartDate}</td>
                        <td>{suspension.ExpiryDate}</td>
                    </tr>
                </tbody>
                <thead>
                    <tr>
                        <th colspan="2" scope="col">Suspension Type</th>
                    </tr>
                </thead>
                <tbody>
                    {suspension.SuspensionTypes.map((details => (
                        <tr>

                            <td colspan="2">{details}</td>
                        </tr>
                    )))}
                </tbody>
            </table></>
        )
    } return
    
}
function CheckConvictions({convictions}) {
    if(convictions !== undefined && convictions !== null && convictions !== '' && convictions.length !== 0) {
        return(
       <><th> U.S. Convictions</th><table className="table table-striped table-bordered" >
            <thead>
                <tr>
                    <th scope="col">Citation Date</th>
                    <th scope="col">Conviction Date</th>
                    <th scope="col">Conviction ID</th>
                    <th scope="col">State of Conviction</th>
                    <th scope="col">Court Type</th>
                    <th scope="col">ACD Code</th>
                    <th scope="col">ACD Details</th>
                    <th scope="col">CDL Holder</th>
                    <th scope="col">CMV</th>
                    <th scope="col">Hazmat</th>
                    <th scope="col">Locator Ref.</th>
                    <th scope="col">State Code</th>

                </tr>
            </thead>
            <tbody>
                {convictions.map((details => (
                    <tr>
                        <td>{details.CitationDate}</td>
                        <td>{details.ConvictionDate}</td>
                        <td>{details.ConvictionIdCode}</td>
                        <td>{details.JurisdictionCodeConvicting}</td>
                        {details.ConvictionCourtType !== "" && details.ConvictionCourtType.split('-')[1] ? <td>{details.ConvictionCourtType.split('-')[1]}</td> : <td>{details.ConvictionCourtType}</td>}

                        <td>{details.ConvictionOffenseAcdCode.Code} - {details.ConvictionOffenseAcdCode.Description}</td>
                        <td>{details.ConvictionOffenseDetailAcd}</td>
                        {details.CitationCdlHolderIndicator !== "" && details?.CitationCdlHolderIndicator?.split('-')[1] ? <td>{details.CitationCdlHolderIndicator.split('-')[1]}</td> : <td>{details.CitationCdlHolderIndicator}</td>}
                        {details.ConvictionCommercialVehInd !== "" && details?.ConvictionCommercialVehInd?.split('-')[1] ? <td>{details.ConvictionCommercialVehInd.split('-')[1]}</td> : <td>{details.ConvictionCommercialVehInd}</td>}
                        {details.ConvictionHazmatInd !== "" && details?.ConvictionHazmatInd?.split('-')[1] ? <td>{details.ConvictionHazmatInd.split('-')[1]}</td> : <td>{details.ConvictionHazmatInd}</td>}

                        <td>{details.ConvictionJurisCourtReportId}</td>
                        <td>{details.ConvictionJurisdictionOffenseCode}</td>
                    </tr>
                )))}
            </tbody>
        </table></> 
        )
    } return
}
function CheckWithdrawals({withdrawals}) {
    if(withdrawals !== undefined && withdrawals !== null && withdrawals.length > 0) {
        return(
        <><th>Withdrawals</th><table className="table table-striped table-bordered" >
            <thead>
                <tr>
                    <th scope="col">Effective Date</th>
                    <th scope="col">Eligibility Date</th>
                    <th scope="col">Rein. Date</th>
                    <th scope="col">Withdrawal ID</th>
                    <th scope="col">Linkage</th>
                    <th scope="col">Action</th>
                    <th scope="col">ACD Code</th>
                    <th scope="col">State</th>
                    <th scope="col">Basis</th>
                    <th scope="col">Extent</th>
                    <th scope="col">Locator Ref.</th>
                    <th scope="col">Reason Ref Code</th>
                    <th scope="col">Due Process Status</th>
                </tr>
            </thead>
            <tbody>
                {withdrawals.map((details => (
                    <tr>
                        <td>{details.DriverLicenseWithdrawalEffectiveDate}</td>
                        <td>{details.DRVLicWithdrawalEligibilityDate}</td>
                        <td>{details.DLWithdrawalReinstatementDate}</td>
                        <td>{details.DriverLicenseWithdrawalIdCode}</td>
                        <td>{details.DLWithdrawalIdConvictionLinksGroup}</td>
                        <td>{details?.DriverLicenseWithdrawalType?.split('-')[1]}</td>
                        {details?.DRVLicAcdWithdrawalReasonCode?.Code ? <td>{details.DRVLicAcdWithdrawalReasonCode.Code} - {details.DRVLicAcdWithdrawalReasonCode.Description} </td> : <td></td>}
                        <td>{details.JurisdictionCodeWithdrawing}</td>
                        <td>{details?.DriverLicenseWithdrawalBasis?.split('-')[1]}</td>
                        <td>{details?.DRVLicWithdrawalExtentIdDlc?.split('-')[1]}</td>
                        <td>{details.DRVLicWithdrawalReasonReference}</td>
                        <td>{details.DLWithdrawalJurisdictionReportId}</td>
                        <td>{details?.DLWithdrawalDueProcessStatus?.split('-')[1]}</td>
                    </tr>
                )))}
            </tbody>
        </table></>
        )
    } return
    
}
function CheckAccidents({accidents}) {
    if(accidents !== undefined && accidents !== null && accidents !== '') {
        return(
            <><th>Accidents</th><table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th scope="col">Accident Date</th>
                        <th scope="col">State</th>
                        <th scope="col">Severity</th>
                        <th scope="col">Driving CMV</th>
                        <th scope="col">Carrying Hazmat</th>
                        <th scope="col">Locator Reference</th>
                    </tr>
                </thead>
                <tbody>
                    {accidents.map((details => (
                        <tr>
                            <td>{details.AccidentDate}</td>
                            <td>{details.AccidentJurisdictionCode}</td>
                            <td>{details.AccidentSeverityCode}</td>
                            <td>{details.DriverAccidentCommercialVehInd}</td>
                            <td>{details.DriverAccidentHazmatInd}</td>
                            <td>{details.AccidentLocatorReference}</td>
                        </tr>
                    )))}
                </tbody>
            </table></>
        )
    } return
}
export default InquiryResponse;